<template>
<component :is="tag" class="btn"><slot></slot></component>
</template>

<script>
export default {
    props: {
        tag: {
            type: String,
            default: 'a'
        }
    }
}
</script>